export default "__VITE_ASSET__kyHPMWan__"